// Page-level loading spinner with ManageClean icon
export function LoadingSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center space-y-4">
        <img src="/mc-icon.svg" alt="Loading" className="h-16 w-16 animate-spin" />
        <p className="text-gray-500">Loading...</p>
      </div>
    </div>
  );
}
